import { render, staticRenderFns } from "./tan_car_wx.vue?vue&type=template&id=9c38ba6a&scoped=true"
import script from "./tan_car_wx.vue?vue&type=script&lang=js"
export * from "./tan_car_wx.vue?vue&type=script&lang=js"
import style0 from "./tan_car_wx.vue?vue&type=style&index=0&id=9c38ba6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c38ba6a",
  null
  
)

export default component.exports